import { inject, Injectable } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";
import { TranslateService } from "@ngx-translate/core";
import { MessageService, ToastMessageOptions } from "primeng/api";
import { Subscription } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class NewVersionCheckerService {
  isNewVersionAvailable: boolean = false;
  newVersionSubscription?: Subscription;
  private swUpdate = inject(SwUpdate);
  private messageService = inject(MessageService);
  private translateService = inject(TranslateService);
  messageNewVersion: ToastMessageOptions = {
    key: "newversion",
    sticky: false,
    severity: "info",
    summary: "refresh",
    life: 200000,
    styleClass: "rounded-xl border-primary",
  };
  constructor() {
    this._checkForUpdate();
  }

  public applyUpdate(): void {
    this.swUpdate
      .activateUpdate()
      .then(() => document.location.reload())
      .catch((error) => console.error("Failed to apply updates:", error));
  }

  private _checkForUpdate(): void {
    setTimeout(() => {}, 2000);
    this.newVersionSubscription?.unsubscribe();
    if (!this.swUpdate.isEnabled) {
      return;
    }
    this.newVersionSubscription = this.swUpdate.versionUpdates.subscribe((evt) => {
      switch (evt.type) {
        case "VERSION_READY":
          if (this.isNewVersionAvailable) break;
          this.isNewVersionAvailable = true;
          this.messageNewVersion.summary = this.translateService.instant("checkVersion.newVersion");
          this.messageService.add(this.messageNewVersion);
          break;
      }
    });
  }
}
